import React from 'react';

const Loading = ({ message = "Please wait while your data is loading" }) => {
  return (
    <div className="dashboard-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #9A28CA',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 10px'
          }}
        ></div>
        <p style={{ fontSize: '18px', color: '#9A28CA' }}>{message}</p>
      </div>
    </div>
  );
};

export default Loading;
